var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
var FHIR_QUESTIONNAIRE_MODULE_ASSETS_MAP = {};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(FHIR_QUESTIONNAIRE_MODULE_ASSETS_MAP);
};

// src/components/dynamic-fhir-form/dynamic-fhir-form.component.tsx
import React8, { forwardRef, useMemo } from "react";

// src/utils/fhir-parser/item-extension-handlers/fhir-core-extension-handlers.util.ts
var regexExtensionHandler = (extension) => __spreadProps(__spreadValues({}, extension), {
  type: "regex"
});

// src/utils/fhir-parser/item-type-handlers/boolean-item-type-handler.util.ts
var handleItemTypeBoolean = (item) => item;
var handleAnswerTypeBoolean = (value) => [
  {
    valueBoolean: value === "true"
  }
];

// src/utils/fhir-parser/item-type-handlers/choice-item-type-handler.util.ts
var handleItemTypeChoice = (item) => {
  var _a;
  let inputType;
  (_a = item.extension) == null ? void 0 : _a.map((extension) => {
    var _a2, _b;
    if (/StructureDefinition\/questionnaire-itemControl\/?/gi.test(extension.url)) {
      inputType = (_b = (_a2 = extension == null ? void 0 : extension.valueCodeableConcept) == null ? void 0 : _a2.coding) == null ? void 0 : _b[0].code;
    }
    return extension;
  });
  return __spreadProps(__spreadValues({}, item), { inputType });
};
var handleAnswerTypeChoice = (value) => {
  if (Array.isArray(value)) {
    return value.map((individualAnswer) => ({
      valueCoding: {
        code: individualAnswer
      }
    }));
  }
  return [
    {
      valueCoding: {
        code: value
      }
    }
  ];
};

// src/utils/fhir-parser/item-type-handlers/integer-item-type-handler.util.ts
var handleItemTypeInteger = (item) => item;
var handleAnswerTypeInteger = (value) => [
  {
    // Ensuring the returned value is an integer.
    // Required to satisfy TS since the value could `technically` be a string
    valueInteger: Math.trunc(Number(value))
  }
];

// src/utils/fhir-parser/item-type-handlers/url-item-type-handler.util.ts
var handleItemTypeUrl = (item) => item;
var handleAnswerTypeUrl = (value) => [
  {
    valueUri: value
  }
];

// src/utils/fhir-parser/item-type-handlers/string-item-type-handler.util.ts
var handleItemTypeString = (item) => item;
var handleAnswerTypeString = (value) => [
  {
    valueString: value
  }
];

// src/utils/fhir-parser/item-and-answer-handlers-by-type.util.ts
var handleAnswerByType = (answerType, value) => {
  switch (answerType) {
    case "boolean":
      return handleAnswerTypeBoolean(value);
    case "choice":
      return handleAnswerTypeChoice(value);
    case "integer":
      return handleAnswerTypeInteger(value);
    case "string":
      return handleAnswerTypeString(value);
    case "url":
      return handleAnswerTypeUrl(value);
    default:
      return [{ valueString: value }];
  }
};
var handleExtensions = (extensions) => extensions.map((extension) => {
  if (/StructureDefinition\/regex\/?/gi.test(extension.url)) {
    return regexExtensionHandler(extension);
  }
  return extension;
});
var handleQuestionByType = (item) => {
  const parsedItem = item;
  if (parsedItem == null ? void 0 : parsedItem.extension) {
    parsedItem.extension = handleExtensions(parsedItem.extension);
  }
  switch (parsedItem.type) {
    case "boolean":
      return handleItemTypeBoolean(parsedItem);
    case "choice":
      return handleItemTypeChoice(parsedItem);
    case "integer":
      return handleItemTypeInteger(parsedItem);
    case "url":
      return handleItemTypeUrl(parsedItem);
    case "string":
      return handleItemTypeString(parsedItem);
    default:
      return parsedItem;
  }
};

// src/utils/fhir-parser/fhir-parser.util.ts
var handleAnswerWithNestedItem = (item, values) => {
  if (values[item.linkId]) {
    const answer = handleAnswerByType(item.type, values[item.linkId]);
    return {
      linkId: item.linkId,
      answer: [answer, { item: item.item }]
    };
  }
  return {};
};
var handleAnswerWithoutNestedItem = (item, values) => {
  const answer = handleAnswerByType(
    item.type,
    values[item.linkId]
  );
  if (values[item.linkId]) {
    return {
      linkId: item.linkId,
      answer
    };
  }
  return {};
};
var handleAnswerArray = (item, values) => {
  if (item.type === "group") {
    return {
      linkId: item.linkId,
      item: item.item
    };
  }
  if (item.type === "display") {
    return {
      linkId: item.linkId
    };
  }
  if (item.item) {
    return handleAnswerWithNestedItem(item, values);
  }
  return handleAnswerWithoutNestedItem(item, values);
};
var iterateOverQuestionnaireToGenerateFrontEnd = (itemArray) => itemArray.map((item) => {
  const parsedItem = handleQuestionByType(item);
  if (item.item) {
    parsedItem.item = iterateOverQuestionnaireToGenerateFrontEnd(item.item);
    return parsedItem;
  }
  return parsedItem;
});
var iterateOverQuestionnaireItemToGenerateResponse = (itemArray, values) => itemArray.map((item) => {
  if (item.item) {
    return iterateOverQuestionnaireItemToGenerateResponse(
      item.item,
      values
    );
  }
  return handleAnswerArray(item, values);
}).filter(
  (item) => item == null ? void 0 : item.linkId
);
var generateQuestionnaireResponse = (FHIRQuestionnaire, values) => {
  if ((FHIRQuestionnaire == null ? void 0 : FHIRQuestionnaire.item) && FHIRQuestionnaire.item.length > 0) {
    const questionnaireResponseItem = FHIRQuestionnaire.item.map((questionnaireItem) => {
      if (questionnaireItem.item) {
        const responseItem = iterateOverQuestionnaireItemToGenerateResponse(
          questionnaireItem.item,
          values
        );
        return handleAnswerArray(
          __spreadProps(__spreadValues({}, questionnaireItem), { item: responseItem }),
          values
        );
      }
      return handleAnswerArray(questionnaireItem, values);
    }).filter(
      (item) => (item == null ? void 0 : item.item) ? item.item.length > 0 : item == null ? void 0 : item.linkId
    );
    return {
      resourceType: "QuestionnaireResponse",
      questionnaire: FHIRQuestionnaire.url || "",
      item: questionnaireResponseItem,
      status: "completed"
    };
  }
  return null;
};
var validateItemsKeys = (items) => {
  const requiredKeys = ["linkId", "type"];
  const invalidItems = items.filter((item) => {
    const itemKeys = Object.keys(item);
    const hasAllRequiredFields = requiredKeys.every(
      (key) => itemKeys.includes(key)
    );
    return !hasAllRequiredFields;
  });
  return invalidItems.length > 0;
};
var getParsedFHIRQuestionnaireAndResponseBuilder = (FHIRQuestionnaire) => {
  if ((FHIRQuestionnaire == null ? void 0 : FHIRQuestionnaire.item) && FHIRQuestionnaire.item.length > 0) {
    const hasInvalidItems = validateItemsKeys(FHIRQuestionnaire.item);
    if (hasInvalidItems)
      return {
        isError: true,
        FHIRQuestionnaireItems: [],
        buildFHIRQuestionnaireResponse: () => {
        }
      };
    const buildFHIRQuestionnaireResponse = (values) => generateQuestionnaireResponse(FHIRQuestionnaire, values);
    const FHIRQuestionnaireItems = iterateOverQuestionnaireToGenerateFrontEnd(
      FHIRQuestionnaire.item
    );
    return {
      isError: false,
      FHIRQuestionnaireItems,
      buildFHIRQuestionnaireResponse
    };
  }
  return {
    isError: false,
    FHIRQuestionnaireItems: [],
    buildFHIRQuestionnaireResponse: () => {
    }
  };
};

// src/components/dynamic-fhir-form/dynamic-fhir-form.component.tsx
import { FormProvider } from "@leagueplatform/web-common";
import { ErrorState } from "@leagueplatform/web-common-components";
import {
  StackLayout,
  Button,
  HeadingText,
  Fieldset
} from "@leagueplatform/genesis-core";

// src/components/radio-group/radio-group.component.tsx
import React from "react";
import { Radio } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { ControlledFieldset } from "@leagueplatform/web-common";

// src/utils/display-slug.util.tsx
var getDisplaySlug = ({
  id,
  option
}) => {
  const { valueCoding } = option;
  const slug = (valueCoding == null ? void 0 : valueCoding.display) ? `-${valueCoding == null ? void 0 : valueCoding.display.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()}` : "";
  return `${id}-${valueCoding == null ? void 0 : valueCoding.code}${slug}`;
};

// src/components/radio-group/radio-group.component.tsx
var RadioGroup = ({
  answerOptions,
  id,
  name,
  legend,
  required = false
}) => {
  var _a, _b;
  const { formatMessage } = useIntl();
  const defaultInputRules = {
    required: {
      value: required,
      message: formatMessage({ id: "PLEASE_MAKE_A_SELECTION" })
    }
  };
  const inputRules = required ? defaultInputRules : {};
  const defaultValue = (_b = (_a = answerOptions.find((option) => option.initialSelected)) == null ? void 0 : _a.valueCoding) == null ? void 0 : _b.code;
  const getLabel = (label) => label == null ? void 0 : label.split("\n")[0];
  const getHint = (label) => label == null ? void 0 : label.split("\n")[1];
  return /* @__PURE__ */ React.createElement(
    ControlledFieldset,
    {
      name,
      inputOptions: __spreadProps(__spreadValues({}, inputRules), {
        value: defaultValue
      }),
      legend,
      id
    },
    answerOptions.map((option) => {
      var _a2;
      const keyAndId = getDisplaySlug({ id, option });
      return /* @__PURE__ */ React.createElement(
        Radio,
        {
          key: keyAndId,
          label: (_a2 = getLabel(option.valueCoding.display)) != null ? _a2 : option.valueCoding.code,
          hint: getHint(option.valueCoding.display),
          name,
          value: option.valueCoding.code,
          id: keyAndId,
          layout: "row"
        }
      );
    })
  );
};

// src/components/checkbox-group/checkbox-group.component.tsx
import React2 from "react";
import { Checkbox } from "@leagueplatform/genesis-core";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import { ControlledFieldset as ControlledFieldset2 } from "@leagueplatform/web-common";
var CheckboxGroup = ({
  answerOptions,
  id,
  name,
  legend,
  required = false
}) => {
  const { formatMessage } = useIntl2();
  const defaultInputRules = {
    required: {
      value: required,
      message: formatMessage({ id: "PLEASE_MAKE_A_SELECTION" })
    }
  };
  const defaultValues = answerOptions.filter((option) => option.initialSelected).map((filterdOption) => {
    var _a;
    return (_a = filterdOption == null ? void 0 : filterdOption.valueCoding) == null ? void 0 : _a.code;
  });
  const inputRules = required ? defaultInputRules : {};
  return /* @__PURE__ */ React2.createElement(
    ControlledFieldset2,
    {
      name,
      inputOptions: __spreadProps(__spreadValues({}, inputRules), {
        value: defaultValues
      }),
      legend,
      id
    },
    answerOptions.map((option) => {
      const keyAndId = getDisplaySlug({ id, option });
      return /* @__PURE__ */ React2.createElement(
        Checkbox,
        {
          key: keyAndId,
          label: option.valueCoding.display || option.valueCoding.code,
          name,
          value: option.valueCoding.code,
          id: keyAndId,
          layout: "row"
        }
      );
    })
  );
};

// src/components/display/display.component.tsx
import React3 from "react";
import { ParagraphText } from "@leagueplatform/genesis-core";
var Display = ({ text }) => text ? /* @__PURE__ */ React3.createElement(ParagraphText, null, text) : null;

// src/components/text-input/text-input.component.tsx
import React4 from "react";
import { TextInput as GenesisTextInput } from "@leagueplatform/genesis-core";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { ControlledFormField } from "@leagueplatform/web-common";
var TextInput = ({
  labelText,
  defaultValue,
  id,
  name,
  required,
  regex,
  maxLength
}) => {
  const { formatMessage } = useIntl3();
  const inputRules = __spreadValues(__spreadValues(__spreadValues({}, required && {
    required: {
      value: true,
      message: formatMessage({ id: "THIS_FIELD_IS_REQUIRED" })
    }
  }), maxLength && {
    maxLength: {
      value: maxLength,
      message: `You are over the maximum character limit (${maxLength})`
    }
  }), regex && {
    pattern: {
      value: new RegExp(regex),
      message: "Please enter a valid format"
    }
  });
  return /* @__PURE__ */ React4.createElement(
    ControlledFormField,
    {
      name,
      id: name,
      inputOptions: __spreadProps(__spreadValues({}, inputRules), {
        value: defaultValue
      }),
      label: labelText
    },
    /* @__PURE__ */ React4.createElement(GenesisTextInput, { id })
  );
};

// src/components/text-area-input/text-area-input.component.tsx
import React5 from "react";
import { Textarea } from "@leagueplatform/genesis-commons";
import { ControlledFormField as ControlledFormField2 } from "@leagueplatform/web-common";
import { useIntl as useIntl4 } from "@leagueplatform/locales";
var TextAreaInput = ({
  name,
  id,
  placeholder,
  labelText,
  required,
  maxLength,
  regex,
  defaultValue
}) => {
  const { formatMessage } = useIntl4();
  const inputRules = __spreadValues(__spreadValues(__spreadValues({}, required && {
    required: {
      value: true,
      message: formatMessage({ id: "THIS_FIELD_IS_REQUIRED" })
    }
  }), maxLength && {
    maxLength: {
      value: maxLength,
      message: `You are over the maximum character limit (${maxLength})`
    }
  }), regex && {
    pattern: {
      value: new RegExp(regex),
      message: "Please enter a valid format"
    }
  });
  return /* @__PURE__ */ React5.createElement(
    ControlledFormField2,
    {
      id,
      name,
      inputOptions: __spreadProps(__spreadValues({}, inputRules), {
        value: defaultValue
      }),
      label: labelText
    },
    /* @__PURE__ */ React5.createElement(Textarea, { id, name, placeholder })
  );
};

// src/components/boolean-group/boolean-group.component.tsx
import React6 from "react";
import { ChoiceButton } from "@leagueplatform/genesis-core";
import { useIntl as useIntl5 } from "@leagueplatform/locales";
import { ControlledFieldset as ControlledFieldset3 } from "@leagueplatform/web-common";
var choiceButtonStyle = {
  width: "50%",
  maxWidth: 248,
  "> label": {
    width: "100%"
  },
  "@mobile": {
    width: "100%",
    maxWidth: "unset"
  }
};
var BooleanGroup = ({
  id,
  name,
  defaultValue,
  legend,
  required
}) => {
  const { formatMessage } = useIntl5();
  const defaultInputRules = {
    required: {
      value: required,
      message: formatMessage({ id: "PLEASE_MAKE_A_SELECTION" })
    }
  };
  const inputRules = required ? defaultInputRules : {};
  return /* @__PURE__ */ React6.createElement(
    ControlledFieldset3,
    {
      name,
      inputOptions: __spreadProps(__spreadValues({}, inputRules), {
        value: defaultValue
      }),
      legend,
      id
    },
    /* @__PURE__ */ React6.createElement(
      ChoiceButton,
      {
        css: __spreadProps(__spreadValues({}, choiceButtonStyle), { marginBottom: "$quarter" }),
        inputType: "radio",
        label: formatMessage({ id: "YES" }),
        name,
        id: `${id}-yes`,
        value: "true"
      }
    ),
    /* @__PURE__ */ React6.createElement(
      ChoiceButton,
      {
        css: choiceButtonStyle,
        inputType: "radio",
        label: formatMessage({ id: "NO" }),
        name,
        id: `${id}-no`,
        value: "false"
      }
    )
  );
};

// src/components/select-input/select-input.component.tsx
import React7 from "react";
import { Select } from "@leagueplatform/genesis-core";
import { useIntl as useIntl6 } from "@leagueplatform/locales";
import { ControlledFieldset as ControlledFieldset4 } from "@leagueplatform/web-common";
var SelectInput = ({
  answerOptions,
  id,
  name,
  legend,
  required
}) => {
  var _a, _b;
  const { formatMessage } = useIntl6();
  const defaultInputRules = {
    required: {
      value: required,
      message: formatMessage({ id: "PLEASE_MAKE_A_SELECTION" })
    }
  };
  const defaultValue = (_b = (_a = answerOptions.find((option) => option.initialSelected)) == null ? void 0 : _a.valueCoding) == null ? void 0 : _b.code;
  const inputRules = required ? defaultInputRules : {};
  return /* @__PURE__ */ React7.createElement(
    ControlledFieldset4,
    {
      name,
      inputOptions: __spreadValues({}, inputRules),
      legend,
      id
    },
    /* @__PURE__ */ React7.createElement(
      Select,
      {
        id,
        "aria-label": name,
        css: { width: "350px" },
        placeholder: "select an option",
        defaultValue
      },
      answerOptions.map((option) => {
        var _a2;
        return /* @__PURE__ */ React7.createElement(
          "option",
          {
            key: getDisplaySlug({ id, option }),
            value: option.valueCoding.code
          },
          (_a2 = option.valueCoding.display) != null ? _a2 : option.valueCoding.code
        );
      })
    )
  );
};

// src/components/dynamic-fhir-form/dynamic-fhir-form.component.tsx
import { useIntl as useIntl7 } from "@leagueplatform/locales";
var DynamicFHIRForm = forwardRef(
  ({
    FHIRQuestionnaire,
    setQuestionnaireAnswer,
    handleSubmitInParent
  }, ref) => {
    const { formatMessage } = useIntl7();
    const { isError, FHIRQuestionnaireItems, buildFHIRQuestionnaireResponse } = useMemo(() => {
      const parsedFHIRQuestionnaireAndResponseBuilder = getParsedFHIRQuestionnaireAndResponseBuilder(FHIRQuestionnaire);
      return {
        isError: parsedFHIRQuestionnaireAndResponseBuilder.isError,
        FHIRQuestionnaireItems: parsedFHIRQuestionnaireAndResponseBuilder.FHIRQuestionnaireItems,
        buildFHIRQuestionnaireResponse: parsedFHIRQuestionnaireAndResponseBuilder.buildFHIRQuestionnaireResponse
      };
    }, [FHIRQuestionnaire]);
    const handleSubmit = (data) => {
      const response = buildFHIRQuestionnaireResponse(data);
      setQuestionnaireAnswer(response);
    };
    const renderQuestionnaireItems = (questionnaireItems) => questionnaireItems.map((item) => {
      var _a, _b, _c, _d, _e, _f;
      if (item.type === "boolean") {
        return /* @__PURE__ */ React8.createElement(
          BooleanGroup,
          {
            key: item.linkId,
            name: item.linkId,
            id: item.linkId,
            legend: item.text,
            required: !!item.required
          }
        );
      }
      if (item.type === "choice") {
        if (item.inputType === "radio-button") {
          return /* @__PURE__ */ React8.createElement(
            RadioGroup,
            {
              key: item.linkId,
              answerOptions: item.answerOption || [{}],
              name: item.linkId,
              id: item.linkId,
              legend: item.text,
              required: !!item.required
            }
          );
        }
        if (item.inputType === "drop-down") {
          return /* @__PURE__ */ React8.createElement(
            SelectInput,
            {
              key: item.linkId,
              answerOptions: item.answerOption || [{}],
              name: item.linkId,
              id: item.linkId,
              legend: item.text,
              required: !!item.required
            }
          );
        }
        if (item.inputType === "check-box") {
          return /* @__PURE__ */ React8.createElement(
            CheckboxGroup,
            {
              key: item.linkId,
              answerOptions: item.answerOption || [{}],
              name: item.linkId,
              id: item.linkId,
              legend: item.text,
              required: !!item.required
            }
          );
        }
      }
      if (item.type === "display") {
        return /* @__PURE__ */ React8.createElement(Display, { key: item.linkId, text: item.text });
      }
      if (item.type === "string") {
        return /* @__PURE__ */ React8.createElement(
          TextInput,
          {
            key: item.linkId,
            id: item.linkId,
            labelText: item.text,
            name: item.linkId,
            required: !!item.required,
            regex: (_b = (_a = item.extension) == null ? void 0 : _a.find((ext) => ext.type === "regex")) == null ? void 0 : _b.valueString,
            maxLength: item.maxLength,
            defaultValue: item.initial && ((_c = item.initial[0]) == null ? void 0 : _c.valueString)
          }
        );
      }
      if (item.type === "text") {
        return /* @__PURE__ */ React8.createElement(
          TextAreaInput,
          {
            key: item.linkId,
            name: item.linkId,
            id: item.linkId,
            labelText: item.text,
            regex: (_e = (_d = item.extension) == null ? void 0 : _d.find((ext) => ext.type === "regex")) == null ? void 0 : _e.valueString,
            required: !!item.required,
            maxLength: item.maxLength,
            defaultValue: item.initial && ((_f = item.initial[0]) == null ? void 0 : _f.valueString)
          }
        );
      }
      if (item.type === "group" && item.item) {
        return (
          // TODO: PCHAT-2596 check if fieldset complies with a11y guidelines
          /* @__PURE__ */ React8.createElement(
            Fieldset,
            {
              key: item.linkId,
              legend: /* @__PURE__ */ React8.createElement(HeadingText, { level: "3", size: "sm" }, item.text)
            },
            /* @__PURE__ */ React8.createElement(StackLayout, { spacing: "$one" }, renderQuestionnaireItems(item.item))
          )
        );
      }
      return null;
    });
    if (isError)
      return /* @__PURE__ */ React8.createElement(ErrorState, null);
    return /* @__PURE__ */ React8.createElement(
      FormProvider,
      {
        formOptions: {
          mode: "onSubmit"
        },
        includesFormElement: true,
        onError: () => {
          console.log("error");
        },
        onSubmit: handleSubmit
      },
      /* @__PURE__ */ React8.createElement(StackLayout, { spacing: "$one", css: { marginTop: "$oneAndHalf" } }, /* @__PURE__ */ React8.createElement(HeadingText, { level: "2", size: "xxl" }, FHIRQuestionnaire == null ? void 0 : FHIRQuestionnaire.title), renderQuestionnaireItems(FHIRQuestionnaireItems), handleSubmitInParent ? /* @__PURE__ */ React8.createElement(Button, { type: "submit", ref, css: { visibility: "hidden" } }, formatMessage({ id: "SUBMIT" })) : /* @__PURE__ */ React8.createElement(Button, { type: "submit" }, formatMessage({ id: "SUBMIT" })))
    );
  }
);

// src/index.ts
initModule();
export {
  DynamicFHIRForm
};
//# sourceMappingURL=index.js.map